import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const SidebarHeader = styled.h3`
    ${fonts.h700};
    margin-top: ${token('space.200', '16px')};
    margin-bottom: ${token('space.300', '24px')};
    flex-shrink: 0; /* only want to shrink the draggable cards list */
`;

export const EmptyStateMessage = styled.p`
    font-size: ${fonts.xsmall};
    color: ${token('color.text.subtle', colors.N200)};
    padding-top: ${token('space.100', '8px')};
    padding-bottom: ${token('space.100', '8px')};
    width: 60%;
    margin: auto;
`;
